import { render, staticRenderFns } from "./ChangesHistory.vue?vue&type=template&id=3403affa&scoped=true"
import script from "./ChangesHistory.vue?vue&type=script&lang=js"
export * from "./ChangesHistory.vue?vue&type=script&lang=js"
import style0 from "./ChangesHistory.vue?vue&type=style&index=0&id=3403affa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3403affa",
  null
  
)

export default component.exports